var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('ImageHeader'),_c('Text1',{attrs:{"id":"text1"}}),_c('Text2',{attrs:{"id":"text2"}}),_c('Text3',{attrs:{"href":"#","id":"text3"}}),_c('Text4'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }